import {axios} from '@/store/config';

export default {
  // state
  state : {
    oncallItems : [],
    userEmail: ''
  },
  // getters
  getters : {
    oncallItems: state => state.oncallItems,
    userEmail: state => state.userEmail
  },

  // actions
  actions : {

    getUser({ commit }, {query = ""} = {}){
      console.log("get user")
      return new Promise((resolve, reject) => {
        axios.get('/user/info').then((response) => {
          commit('setUserEmail', response.data && response.data.email ? response.data.email : "Ingen epost");

          resolve(response.data);
        }).catch(reject)
      })
    },

    /**
     * Hämta suggestions för beredskapssök
     */
    getOncallItems({ commit }, {query = ""}){
      return new Promise((resolve, reject) => {
        axios.get(`/maintenance/search?q=${query}`).then((response) => {
          commit('setOncallItems', response.data);

          resolve(response.data);
        }).catch(reject)
      })
    },


    /**
     * Skapar felanmälan på kommersiella lokaler
     */
    createOncallErrorReport({ commit, dispatch }, errorReport){
      return new Promise((resolve, reject) => {
        axios.post('maintenance/create', errorReport ).then((response) => {
          resolve(response.data);
        }).catch(reject)
      })
    }
  },

  // mutations
  mutations : {
    setOncallItems(state, commercialPremises){
      state.commercialPremises = commercialPremises;
    },
    setUserEmail(state, user){
      state.userEmail = user;
    }
  }
}
